import * as React from 'react';

import {MessageRoom} from "../../../../../domain/model/message_room";
import {Company} from "../../../../../domain/model/company";
import {Project} from "../../../../../domain/model/project";
import {Message} from "../../../../../domain/model/message";

import {TCompanyWithProjectID} from "../../../../../domain/repository/company_repository";
import MessageRoomCard from "../../../../common/organism/card/message_room_card";
import {Long} from "protobufjs";

interface IProps {
    messageRooms: MessageRoom[];
    companyWithProjectIDs: TCompanyWithProjectID[];
    projects: Project[];
    latestMessages: Message[];
    isMessageRooms: boolean;
    initialMessageRoom: MessageRoom | null;
}

export const CustomerMessageRoomCards: React.FC<IProps> = (props) => {
    const { messageRooms, companyWithProjectIDs, projects, latestMessages, isMessageRooms, initialMessageRoom} = props;

    // projectId: Companyの連想配列を作成し、MessageRoomから連携させる。
    const hashCompany: { [projectID: string]: Company; } = {};
    for (const item of companyWithProjectIDs) {
        hashCompany[item.projectID] = item.company;
    }

    // Projectの連想配列を作成し、MessageRoomから連携させる。
    const hashProject: { [projectId: string]: Project; } = {};
    for (const item of projects) {
        hashProject[item.id] = item;
    }

    // latestMessageListの連想配列を作成し、MessageRoomから連携させる。
    const hashLatestMessage: { [roomId: string]: Message; } = {};
    for (const item of latestMessages) {
        hashLatestMessage[item.roomID] = item;
    }

    return (
        <React.Fragment>
            {messageRooms.map((messageRoom: MessageRoom) => {
                const roomId: string = messageRoom.projectID + "-" + messageRoom.customerID + "-" + messageRoom.companyID;
                const linkURL: string = `/customer/message/${messageRoom.projectID}/${messageRoom.customerID }/${messageRoom.companyID }`;
                const company: Company | undefined = hashCompany[messageRoom.projectID];
                const latestMessage: Message | undefined = hashLatestMessage[roomId];
                const project: Project | undefined = hashProject[messageRoom.projectID];
                if ( !company || !project ) { return null }
                const companyIconURL: string = company.getLogoURL();
                const companyName: string = company.name;
                const customerUnRead: boolean = messageRoom.customerUnRead;
                const customerUnReadCount: number | Long = messageRoom.customerUnReadCount;
                const isScout: boolean = messageRoom.isScout;
                const projectId = messageRoom.projectID;
                const opponentId = messageRoom.companyID;
                const initialProjectId = initialMessageRoom ? initialMessageRoom.projectID : "";
                const initialOpponentId = initialMessageRoom ? initialMessageRoom.companyID : "";
                const isInitialMessageRoom = projectId === initialProjectId && opponentId === initialOpponentId;
                const isInitialActive = isMessageRooms && isInitialMessageRoom;

                return (
                    <MessageRoomCard
                        key={roomId}
                        latestMessage={latestMessage}
                        project={project}
                        linkURL={linkURL}
                        opponentAvatarURL={companyIconURL}
                        opponentName={companyName}
                        unRead={customerUnRead}
                        unReadCount={customerUnReadCount}
                        isScout={isScout}
                        isInitialActive={isInitialActive}
                    />
                )
            })}
        </React.Fragment>
    )

};

export default CustomerMessageRoomCards;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/message_rooms/left_side/customer_message_room_cards.tsx